<template>
  <div class="group_stage">
    <h2 class="title">{{score_list.name}}</h2>
    <div class="group_list">
      <p class="mess_top">最多选择竞猜{{score_list.item_limite}}场比赛</p>
      <template v-for="item in groups">
        <div class="group_item">
          <div class="score_team">
            <template v-for="item2,index in item.item_name">
              <div class="team" v-if="index == 0">
                <span>{{item2.mess}}</span><input class="comm_input score_input"
                                                  @change="storageCheck(item.id,index,item2.mess,$event)" type="number"
                                                  placeholder="比分"/>
              </div>
              <!--            VS-->
              <div class="team" v-else>
                <span>{{item2.mess}}</span><input class="comm_input score_input"
                                                  @change="storageCheck(item.id,index,item2.mess,$event)" type="number"
                                                  placeholder="比分"/>
              </div>
            </template>
          </div>
        </div>
      </template>

    </div>
    <template v-if="!score_list.result">
      <div class="sel_list addmargin">
        <span>获取方式：</span>
        <select class="select_title comm_sel" @change="changeGetOption()" v-model="options">
          <option value="现场领取">现场领取</option>
          <option value="邮寄">邮寄</option>
        </select>
      </div>
      <div class="address_box" v-if="is_option">
        <div class="input_box">
          <span>收件人：</span>
          <div class="ins">
            <input class="comm_input" placeholder="收件人" type="text" v-model="input_val1"/>
          </div>
        </div>
        <div class="input_box">
          <span>联系方式：</span>
          <div class="ins">
            <input class="comm_input" placeholder="手机号" type="text" v-model="input_val2"/>
          </div>
        </div>
        <div class="input_box">
          <span>邮寄地址：</span>
          <div class="ins">
            <input class="comm_input" placeholder="邮寄地址" type="text" v-model="input_val3"/>
          </div>
        </div>
      </div>
      <p class="mess_bottom" v-if="!is_option">{{score_list.self_take}}</p>

      <button class="sub_btn"
              :disabled="score_list.guess_count>=score_list.limite_guess_count || score_list.is_over_time==1"
              @click="subMess">{{score_list.is_over_time==1? '竞猜已结束' : '提交'}}
      </button>
    </template>
    <template v-if="score_list.result">
      <button class="sub_btn" disabled="true">您的竞猜结果是：{{score_list.result}}</button>
    </template>
  </div>
</template>

<script>


    export default {
        name: "TeamScore",
        props: {
            score_list: {},
            tab_list: {}
        },
        data() {
            return {
                tablist1: '',
                tablist2: '',
                value1: '',
                value2: '',
                is_option: true,
                input_val1: '',
                input_val2: '',
                input_val3: '',
                options: '邮寄',
                group_s: [],
                group_radio: 1,
                mess_list: [],
                store_ids: [],
                result: ''
            }
        },
        computed: {
            address() {
                return '收件人：'+this.input_val1+',联系方式'+this.input_val2+',邮寄地址：'+this.input_val3
            },
            groups() {
                for (let i = 0; i < this.tab_list.length; i++) {
                    let group_ass1 = {}
                    group_ass1.name1 = this.tab_list[i].name.split('|')[0];
                    group_ass1.name2 = this.tab_list[i].name.split('|')[1];
                    group_ass1.id = this.tab_list[i].id;
                    group_ass1.item_name = [{
                        mess: group_ass1.name1,
                    }, {
                        mess: group_ass1.name2,
                    }];
                    this.group_s.push(group_ass1);
                }
                return this.group_s
            },
        },
        watch: {
            tab_list: function (newValue) {
                this.tablist1 = newValue[0].name;
                this.tablist2 = newValue[1].name;
                return this.tablist1 + this.tablist2
            }
        },
        methods: {
            storageCheck(id, index, score, $event) {

                let temp = {id: id, index: index, score: score, store_v: $event.target.value};
                if (temp.store_v !='') {
                this.mess_list.map((v, i) => {
                    if (v.id === id && v.index === index) {
                        this.mess_list.splice(i, 1)
                        console.log(this.mess_list);
                    }

                })
                    this.mess_list.push(temp);
                }else {
                    this.mess_list.map((v, i) => {
                        if (v.id === id && v.index === index) {
                            this.mess_list.splice(i, 1)
                            console.log(this.mess_list);
                        }

                    })
                }

            },
            subMess() {
                if (this.options == '邮寄') {

                    if (this.input_val1 != '' && this.input_val2 != '' && this.input_val3 != '') {
                        let arrs = [];
                        let obj1 = {}
                        if (this.mess_list.length > 0) {
                            this.mess_list.reduce((pre, cur) => {
                                if (pre.id == cur.id) {
                                    obj1 = {
                                        id: cur.id,
                                        name1: pre.score,
                                        name2: cur.score,
                                        store_num1: pre.store_v,
                                        store_num2: cur.store_v
                                    }
                                    arrs.push(obj1)
                                }
                                pre = cur;
                                return pre;
                            })
                            for (let i = 0; i < arrs.length; i++) {
                                this.result += arrs[i].name1 + 'VS' + arrs[i].name2 + ':' + arrs[i].store_num1 + '比' + arrs[i].store_num2 + ',';
                            }
                            if (arrs.length != this.score_list.item_limite) {
                                console.log(this.result)
                                alert('请参与' + this.score_list.item_limite + '场比赛的竞猜');
                                return false
                            } else {
                                console.log(this.result);
                                this.$axios({
                                    url: 'https://api.hainanfa.org.cn/guess/Submite',
                                    method: 'post',
                                    params: {
                                        item_id: this.score_list.id,
                                        result: encodeURI(this.result),
                                        match_id: this.score_list.match_id,
                                        user_id: localStorage.getItem("id"),
                                        email_address: encodeURI(this.address)
                                    },
                                    headers: {
                                        'Content-Type': 'application/json;charset=utf-8'
                                    }
                                }).then(res => {
                                    console.log(res)
                                    if (res.data.status == 0) {
                                        alert('提交成功')
                                        this.$router.push({path: 'list'})
                                    }
                                    if (res.data.status == 400002) {
                                        alert('您已经竞猜过了，看看别的吧')
                                        this.$router.push({path: 'list'})
                                    }

                                }).catch(err => {
                                    console.log(err)
                                })
                            }
                        } else {
                            alert('请参与' + this.score_list.item_limite + '场比赛的竞猜');
                        }

                    } else {
                        console.log(this.input_val1, this.input_val2, this.input_val3)
                        alert('请填写好您的信息')
                    }
                } else {
                    let arrs = [];
                    let obj1 = {}
                    if (this.mess_list.length > 0) {
                        this.mess_list.reduce((pre, cur) => {
                            if (pre.id == cur.id) {
                                obj1 = {
                                    id: cur.id,
                                    name1: pre.score,
                                    name2: cur.score,
                                    store_num1: pre.store_v,
                                    store_num2: cur.store_v
                                }
                                arrs.push(obj1)
                            }
                            pre = cur;
                            return pre;
                        })
                        for (let i = 0; i < arrs.length; i++) {
                            this.result += arrs[i].name1 + 'VS' + arrs[i].name2 + ':' + arrs[i].store_num1 + '比' + arrs[i].store_num2 + ',';
                        }
                        if (arrs.length != this.score_list.item_limite) {
                            console.log(this.result)
                            alert('请参与' + this.score_list.item_limite + '场比赛的竞猜');
                            return false
                        } else {
                            console.log(this.result);
                            this.$axios({
                                url: 'https://api.hainanfa.org.cn/guess/Submite',
                                method: 'post',
                                params: {
                                    item_id: this.score_list.id,
                                    result: encodeURI(this.result),
                                    match_id: this.score_list.match_id,
                                    user_id: localStorage.getItem("id"),
                                    email_address: encodeURI('用户现场自取')
                                },
                                headers: {
                                    'Content-Type': 'application/json;charset=utf-8'
                                }
                            }).then(res => {
                                console.log(res)
                                if (res.data.status == 0) {
                                    alert('提交成功')
                                    this.$router.push({path: 'list'})
                                }
                                if (res.data.status == 400002) {
                                    alert('您已经竞猜过了，看看别的吧')
                                    this.$router.push({path: 'list'})
                                }

                            }).catch(err => {
                                console.log(err)
                            })
                        }
                    } else {
                        alert('请参与' + this.score_list.item_limite + '场比赛的竞猜');
                    }

                }

            },
            changeGetOption() {
                this.is_option = !this.is_option;
                console.log(this.score_list)
            }
        }
    }
</script>

<style scoped>
  .title {
    font-size: 22px;
    font-weight: bold;
    color: #000000;
    line-height: 1.5;
  }

  .mess_top {
    font-size: 12px;
    color: red;
    margin: 6px 0;
  }

  .group_stage {
    margin: 20px 0;
    line-height: 1.5;
  }

  .group_item {
    line-height: 1.5;
    margin-bottom: 12px;
  }

  .p_title {
    font-size: 18px;
    color: #333333;
  }

  .summary {
    font-size: 16px;
    color: #666666;
    margin: 2px 0;
  }

  .score_team {
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .score_team .team {
    font-size: 14px;
    color: #333333;
    line-height: 1.5em;
    flex: 1;
    position: relative;
    margin-top: 32px;
  }

  .score_team .team:first-child::after {
    content: 'VS';
    display: block;
    position: absolute;
    right: 0;
    top: 50%;
    height: 20px;
    margin-top: -10px;
  }

  .score_team .team span {
    width: 100%;
    display: block;
    text-align: center;
    height: 48px;
  }

  .team .score_input {
    width: 70px;
    height: 30px;
    margin-left: 16px;
    line-height: 30px;
    text-align: center;
    display: block;
    margin: 0 auto;
  }


</style>
